<template>
<div ref="basePanel">    
    <param-panel :config="config" :rs="rs" :isShowMore="true" /><pager-panel :crowCount="config.rowCount" :cpageNo="config.pageNo" :cpageSize="config.pageSize"
    @CFHandler="CFHandler" :selIdx="selIdx" :rightList="config.rights"/><list-panel :config="config" :isAutoLoad='1' :rs="rs" @updateIdx="updateIdx" :selIdx="selIdx" />
</div>
</template>


<script>
import data from "./data"
import mixin from "@/fui/mixin"

export default {
  data() {
    return {
      config: data
    }
  },
  mixins:[mixin.list]
};
</script>
